module.exports = __webpack_public_path__ + "img/ico-traspasar.6688adb7.svg";